export enum TypeOfActivity {
    Main = "Main",
    Secondary = "Secondary"
}

export interface TaxesInput {
    typeOfActivity: TypeOfActivity
    turnOver: number
    expenses: number
    allowance: number
    dependents: number
}